document.addEventListener('alpine:init', () => {
  Alpine.data('collectionFilters', () => ({
    mobileOpen: false,
    activeCount: 0,
    submitting: false,
    priceError: '',
    _submitTimer: null,

    init() {
      var section = this.$el.closest('[data-active-filter-count]');
      this.activeCount = section ? parseInt(section.dataset.activeFilterCount, 10) || 0 : 0;
      this.preservePageSize();
      this.stripPageFromFilterLinks();
    },

    toggleMobile() {
      this.mobileOpen = !this.mobileOpen;
      if (this.mobileOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },

    closeMobile() {
      this.mobileOpen = false;
      document.body.style.overflow = '';
    },

    submitFilter(el) {
      var form = el.closest('form');
      if (form) this.applyFilters(form);
    },

    validatePrice(form) {
      var minInput = form.querySelector('input[name*="gte"]');
      var maxInput = form.querySelector('input[name*="lte"]');
      var min = parseFloat(minInput && minInput.value);
      var max = parseFloat(maxInput && maxInput.value);
      if (!isNaN(min) && !isNaN(max) && min > max) {
        this.priceError = 'Min price cannot exceed max price';
        return;
      }
      this.priceError = '';
      this.applyFilters(form);
    },

    applyFilters(form) {
      if (this.submitting) return;
      this.submitting = true;
      if (this._submitTimer) clearTimeout(this._submitTimer);
      this._submitTimer = setTimeout(() => {
        this.submitting = false;
      }, 8000);
      form.submit();
    },

    clearAll() {
      var url = new URL(window.location);
      var sortBy = url.searchParams.get('sort_by');
      var pageSize = url.searchParams.get('page_size');
      var params = new URLSearchParams();
      if (sortBy) params.set('sort_by', sortBy);
      if (pageSize) params.set('page_size', pageSize);
      var qs = params.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    },

    stripPageFromFilterLinks() {
      document.querySelectorAll('[data-filter-link]').forEach(function(link) {
        try {
          var url = new URL(link.href);
          if (url.searchParams.has('page')) {
            url.searchParams.delete('page');
            link.href = url.toString();
          }
        } catch (e) {}
      });
    },

    preservePageSize() {
      const url = new URL(window.location);
      const pageSize = url.searchParams.get('page_size');
      if (!pageSize) return;

      // Inject hidden page_size input into all filter forms
      document.querySelectorAll('[data-filter-form]').forEach(form => {
        if (!form.querySelector('input[name="page_size"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'page_size';
          input.value = pageSize;
          form.appendChild(input);
        }
      });

      // Append page_size to pagination links
      document.querySelectorAll('nav[aria-label*="Pagination"] a[href]').forEach(link => {
        try {
          const linkUrl = new URL(link.href);
          if (!linkUrl.searchParams.has('page_size')) {
            linkUrl.searchParams.set('page_size', pageSize);
            link.href = linkUrl.toString();
          }
        } catch (e) {
          // Skip malformed URLs
        }
      });
    }
  }));

  Alpine.data('horizontalFilters', () => ({
    openFilter: null,
    _keydownHandler: null,

    init() {
      this._keydownHandler = (e) => {
        if (e.key === 'Escape') this.openFilter = null;
      };
      document.addEventListener('keydown', this._keydownHandler);
    },

    destroy() {
      if (this._keydownHandler) {
        document.removeEventListener('keydown', this._keydownHandler);
        this._keydownHandler = null;
      }
    },

    toggleFilter(index) {
      this.openFilter = this.openFilter === index ? null : index;
    },

    closeAll() {
      this.openFilter = null;
    }
  }));

  Alpine.data('itemsPerPage', () => ({
    setPageSize(size) {
      const url = new URL(window.location);
      url.searchParams.set('page_size', size);
      url.searchParams.delete('page');
      window.location = url.toString();
    }
  }));
});
